import { styled } from "@mui/material/styles";

export const RightSideContentWrapper = styled("div")(({ theme }) => ({
    padding: "0px 20px",
    overflowY: "auto",
    position: 'relative',
    height: "100%",
}));